/** Canonical Carma contact values shared across apps and UI. */
export const CARMA_PHONE_NUMBER = '+61283193210';
export const CARMA_WHATSAPP = 'https://wa.me/61485854551';

/** Google Maps Platform — static URLs and region (not env-configurable). */
export const GOOGLE_MAPS_API_BASE_URL = 'https://maps.googleapis.com/maps/api';
export const GOOGLE_GEOCODING_API_BASE_URL = 'https://geocode.googleapis.com/v4';
export const GOOGLE_PLACES_API_BASE_URL = 'https://places.googleapis.com/v1';
export const GOOGLE_MAPS_REGION = 'AU';
